import React, { useState } from 'react';
import OptionsGridPage from '../pages/OptionsGridPage';
import './OptionsWorkspace.css';

export default function OptionsWorkspace() {
  const [input, setInput] = useState('');
  const [ticker, setTicker] = useState('');

  const submit = event => {
    event.preventDefault();
    const normalized = input.trim().toUpperCase().replace(/\.SA$/, '');
    if (/^[A-Z0-9]{4,12}$/.test(normalized)) setTicker(normalized);
  };

  return (
    <section className="options-workspace">
      <header className="options-workspace-search">
        <div>
          <span>GRADE DE OPÇÕES</span>
          <h1>Consulte a cadeia de um ativo</h1>
          <p>Digite o ticker negociado na B3 para visualizar calls, puts, strikes e a linha ATM.</p>
        </div>
        <form onSubmit={submit}>
          <label htmlFor="options-workspace-ticker">Ativo</label>
          <div>
            <input
              id="options-workspace-ticker"
              value={input}
              onChange={event => setInput(event.target.value.toUpperCase())}
              placeholder="Ex.: PETR4"
              autoComplete="off"
              spellCheck={false}
              maxLength={12}
            />
            <button type="submit">Ver opções</button>
          </div>
        </form>
      </header>
      {ticker ? (
        <OptionsGridPage key={ticker} ticker={ticker} />
      ) : (
        <div className="options-workspace-empty">
          <strong>Informe um ativo para começar.</strong>
          <span>Exemplos com snapshots disponíveis: PETR4, VALE3, ITUB4 e BOVA11.</span>
        </div>
      )}
    </section>
  );
}